import React, { useEffect } from 'react';

const JoinUs = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.fade-on-scroll');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full">
      {/* Hero */}
      <section className="min-h-[60vh] flex items-center justify-center bg-[#F5F1ED] relative overflow-hidden">
        <div className="absolute right-20 top-1/4 w-96 h-96 border border-[#A08872]/10 rounded-full"></div>
        <div className="container mx-auto px-6 py-20 relative z-10">
          <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4 fade-on-scroll opacity-0">CAREERS</p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-serif text-[#2A2A2A] mb-6 fade-on-scroll opacity-0">Join Us</h1>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="space-y-12">
            <div className="fade-on-scroll opacity-0">
              <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-[#2A2A2A] mb-8">
                Build the future with us
              </h2>
              <p className="text-lg text-[#3D3D3D] leading-relaxed">
                UK Stage is built on first-generation entrepreneurship, disciplined execution, and long-term value creation. We seek individuals who share our commitment to building economic platforms that stand the test of time.
              </p>
            </div>
            
            <div className="fade-on-scroll opacity-0">
              <h3 className="text-2xl font-serif text-[#8B7355] mb-4">What We Look For</h3>
              <ul className="space-y-3 text-lg text-[#3D3D3D]">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 mr-4"></span>
                  <span>Execution-led mindset with hands-on operational capability</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 mr-4"></span>
                  <span>Research-driven approach combined with intellectual curiosity</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 mr-4"></span>
                  <span>Long-horizon thinking and commitment to sustained value creation</span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-[#8B7355] rounded-full mt-2 mr-4"></span>
                  <span>Trust-driven collaboration and partnership orientation</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Image Section */}
      <section className="py-0">
        <img 
          src="https://images.unsplash.com/photo-1551731409-43eb3e517a1a?w=1600&q=80" 
          alt="Indian Professional Business"
          className="w-full h-[220px] sm:h-[400px] md:h-[600px] object-cover fade-on-scroll opacity-0"
        />
      </section>

      {/* Opportunities */}
      <section className="py-20 bg-[#EDE8E3]">
        <div className="container mx-auto px-6 max-w-5xl">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif text-[#2A2A2A] mb-8 md:mb-12 fade-on-scroll opacity-0">Current Opportunities</h2>
          
          <div className="space-y-8">
            <div className="bg-white p-8 fade-on-scroll opacity-0 hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-2xl font-serif text-[#2A2A2A] mb-3">Real Estate Investment Analyst</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4">FULL-TIME • DEHRADUN</p>
              <p className="text-lg text-[#3D3D3D] leading-relaxed">
                Support land acquisition strategies, financial modeling, and investment thesis development for real estate opportunities across growth corridors.
              </p>
            </div>
            
            <div className="bg-white p-8 fade-on-scroll opacity-0 hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-2xl font-serif text-[#2A2A2A] mb-3">Development Manager</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4">FULL-TIME • DEHRADUN</p>
              <p className="text-lg text-[#3D3D3D] leading-relaxed">
                Oversee execution of luxury residential and lifestyle infrastructure projects, managing contractors, timelines, and quality standards.
              </p>
            </div>
            
            <div className="bg-white p-8 fade-on-scroll opacity-0 hover:shadow-lg transition-shadow duration-300">
              <h3 className="text-2xl font-serif text-[#2A2A2A] mb-3">Strategic Partnerships Lead</h3>
              <p className="text-sm text-[#8B7355] uppercase tracking-widest mb-4">FULL-TIME • DEHRADUN</p>
              <p className="text-lg text-[#3D3D3D] leading-relaxed">
                Build and maintain relationships with investors, joint venture partners, and institutional stakeholders to support capital formation and strategic initiatives.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-32 bg-[#2A2A2A] text-white text-center">
        <div className="container mx-auto px-6 max-w-4xl fade-on-scroll opacity-0">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif mb-6">
            Ready to build with us?
          </h2>
          <p className="text-xl mb-8">
            Send your resume and cover letter to careers@ukstage.com
          </p>
        </div>
      </section>
    </div>
  );
};

export default JoinUs;